import React, { useState, useEffect, useRef } from 'react'

import {
	Button,
	CircularProgress,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	InputAdornment,
	Typography,
	TextField,
	MenuItem,
	Switch,
	Icon
} from '@material-ui/core'

import Confirmation from '../DeleteConfirmation'

import { TimePicker } from '@material-ui/pickers'

import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles'

const trim_amounts = [
	'No Trim',
	'Feet, Face, Sanitary',
	'Shave',
	'Short Clip',
	'Medium Clip',
	'Long Clip',
	'Outline',
	'Other'
]

const removeAnyDecimal = (str = '') => {
	const withoutDecimal = Math.ceil(parseFloat(str)) // str.split('.')[0]
	return withoutDecimal
}

import _ from 'lodash'
import { USER_ROLES } from '../../../utils/enums'
// const trim_amounts = ['Short Trim', 'Medium Trim', 'Long Trim', 'Breed Specific', 'Doodle']
const useStyles = makeStyles((theme) => ({
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '15px !important'
	},
	header: {
		marginTop: 40,
		marginBottom: 16,
		color: '#1a1a35',
		fontWeight: '800',
		fontSize: 16
	},
	dialogActions: {
		justifyContent: 'flex-start',
		padding: '0px 24px'
	},
	checkbox: {
		'&.Mui-disabled.Mui-checked .MuiIconButton-label .MuiSvgIcon-root': {
			fill: '#A2A1A4'
		}
	},
	column: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	priceColumn: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		width: '49%',
		paddingRight: 24
	},

	avatar: {
		background: '#C4C4C4',
		height: '32px',
		width: '32px',
		marginTop: '12px',
		marginBottom: '12px'
	},
	textField: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		marginBottom: '8px',
		'& .MuiTextField-root': {
			minWidth: '100%',
			marginBottom: '16px'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '100%'
		}
	},
	textField2: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		marginBottom: '8px',
		'& .MuiTextField-root': {
			minWidth: 100,
			marginBottom: '16px',
			width: 150
		},
		'& .MuiFilledInput-underline': {
			minWidth: 100,
			width: 150
		}
	},
	priceColumn2: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		width: '49%',
		paddingRight: 24,
		'& .MuiTextField-root': {
			minWidth: '100% !important',
			width: '100% !important',
			marginBottom: '16px'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '100% !important',
			width: '100% !important'
		}
	},
	sharingWrapper: {
		height: 56,
		width: '100%',
		padding: '0px 12px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: 6,
		background: '#F9F9F9'
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1
			},
			'& .far::before': {
				color: '#6B4AD6'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	},
	checked: {}
}))

const EditAssignmentsDialog = (props) => {
	const classes = useStyles()
	const waiverInputRef = useRef(null)
	const dispatch = useDispatch()
	const user = useSelector((state) => state.general?.user?.user)
	const canEditPrices =
		user?.roles?.includes(USER_ROLES.BackOfficeUser) ||
		user?.roles?.includes(USER_ROLES.SuperUser) ||
		false
	const [daycareWarning, showDaycareWarning] = useState(false)
	const [startTime, updateStartTime] = useState(null)
	const [startTimeOpen, setStartTimeOpen] = useState(false)
	const [duration, updateDuration] = useState()
	const [visit, setVisit] = useState({})
	const [loading, setLoading] = useState(false)
	const [timeError, setTimeError] = useState(false)

	const isDisabled = () => false

	let { isShown, setIsShown, pet, facility, staffList } = props



	useEffect(() => {
		if (props.visit && (!visit._id || visit._id !== props.visit._id)) {
			const { quoted_price_max = 0, quoted_price_min = 0 } = props.visit
			let quotedPriceMax = quoted_price_max
			let quotedPriceMin = quoted_price_min
			if (typeof quotedPriceMax === 'string') {
				quotedPriceMax = removeAnyDecimal(quotedPriceMax)
			}
			if (typeof quotedPriceMax === 'number') {
				quotedPriceMax = Math.ceil(quotedPriceMax)
			}
			if (typeof quotedPriceMin === 'string') {
				quotedPriceMin = removeAnyDecimal(quotedPriceMin)
			}
			if (typeof quotedPriceMin === 'number') {
				quotedPriceMin = Math.ceil(quotedPriceMin)
			}
			setVisit({
				...props.visit,
				quoted_price_max: quotedPriceMax,
				quoted_price_min: quotedPriceMin
			})
		}
	}, [props.visit])

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	const confirmDaycareTime = () => {
		saveVisit(false)
		showDaycareWarning(false)
	}

	const confirmDaycareDropOff = () => {
		// if there is a related daycare visit, prompt the user to confirm the time is correct
		if (visit?.related_visits?.find((v) => v.type === 'daycare')) {
			if (moment(visit.start_time, 'HH:mm').isBefore(moment('09:00', 'HH:mm'))) {
				showDaycareWarning(true)
			} else {
				return saveVisit(false)
			}
		} else {
			return saveVisit(false)
		}
	}

	const saveVisit = (validate = true) => {
		try {
			if (validate) return confirmDaycareDropOff()

			setLoading(true)

			let updates = {
				start_time: visit.start_time,
				duration: visit.duration,
				preferred_staff_id: visit.preferred_staff_id,
				staff_id: visit.staff_id,
				trim_amount: visit.trim_amount,
				quoted_price_min: visit.quoted_price_min ? onlyNumbers(visit.quoted_price_min) : undefined,
				quoted_price_max: visit.quoted_price_max ? onlyNumbers(visit.quoted_price_max) : undefined,
				price: visit.price ? onlyNumbers(visit.price) : undefined,
				notes_from_client: visit.notes_from_client,
				notes_from_team: visit.notes_from_team,
				temp_file: visit.temp_file ? visit.temp_file : null
			}
			props.saveVisit(updates)

			setTimeout(() => {
				setLoading(false)
				setIsShown(false)
			}, 1000)
		} catch (e) {
			console.log('err...', e)
		}
	}

	const renderPhoto = () => {
		let value = ''
		if (visit?.temp_file?.name) value = visit.temp_file.name
		if (visit.reference_photo_url) value = visit.reference_photo_url
		if (!value) return null

		return (
			<div
				style={{
					padding: 10,
					paddingTop: 2,
					paddingBottom: 2,
					backgroundColor: '#F9F9F9',
					borderRadius: 6,
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					width: 250,
					marginBottom: 16
				}}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-start',
						alignItems: 'center',
						width: '80%',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis'
					}}>
					<i className="fa fa-image" style={{ color: '#6B4AD6', marginRight: 8 }} />
					<Typography style={{ color: '#6b4ad6', fontSize: 14, fontWeight: '800' }}>{value}</Typography>
				</div>
				<IconButton
					style={{ fontSize: 18 }}
					onClick={() => {
						setVisit({
							...visit,
							reference_photo_url: '',
							temp_file: null
						})
					}}>
					X
				</IconButton>
			</div>
		)
	}

	const uploadFile = async (e) => {
		try {
			if (e.target.files && e.target.files.length && e.target.files[0]) {
				let file
				file = e.target.files[0]

				setVisit({
					...visit,
					temp_file: e.target.files[0]
				})
			}
		} catch (e) {
			console.log('err...', e)
			// dispatch(showError('Error uploading image.'))
			// setImageLoading(false)
		}
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => {
				setIsShown(false)
			}}
			PaperProps={{
				style: {
					minWidth: '920px',
					maxWidth: '920px',
					width: '920px',
					padding: '24px 0px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 18,
					padding: '0px 24px'
				}}>
				EDIT GROOMING SPECIFICS
			</DialogTitle>
			<DialogContent
				style={{
					padding: '0px 24px'
				}}>
				<Typography variant="body1" className={classes.header} style={{ marginTop: 16 }}>
					Appointment Time
				</Typography>
				<div className={classes.textField}>
					<div className={classes.column}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Scheduled Start Time
						</Typography>
						<TimePicker
							style={{
								minWidth: '400px',
								margin: 0
							}}
							open={startTimeOpen}
							label="Start Time"
							onOpen={() => setStartTimeOpen(true)}
							onClose={() => setStartTimeOpen(false)}
							error={timeError}
							helperText={timeError ? 'Start cannot be before facility visit start time' : ''}
							variant="inline"
							format="hh:mm a"
							margin="normal"
							id="start-date"
							inputVariant="filled"
							value={visit.start_time ? moment(visit.start_time, 'HH:mm') : null}
							onChange={(e) => {
								if (facility?.services?.grooming?.visit_start_time) {
									if (
										e.isBefore(moment(facility?.services?.grooming?.visit_start_time, 'HH:mm'))
									) {
										setTimeError(true)
									} else {
										setTimeError(false)
									}
								}

								setVisit({ ...visit, start_time: e.format('HH:mm') })
							}}
							className={classes.datePicker2}
							KeyboardButtonProps={{
								'aria-label': 'Date',
								className: classes.calendarButton
							}}
						/>
					</div>
					<div className={classes.column} style={{ marginLeft: 24 }}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Expected Duration (minutes)
						</Typography>
						<TextField
							style={{
								minWidth: '400px',
								margin: 0
							}}
							label="Expected Duration (minutes)"
							variant="filled"
							disabled={visit?.status?.id === 5}
							value={visit.duration}
							type="number"
							onChange={(e) => setVisit({ ...visit, duration: e.target.value })}
						/>
					</div>
				</div>

				<Typography variant="body1" className={classes.header}>
					Grooming Assignment
				</Typography>

				<div className={classes.textField}>
					<div className={classes.column}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Preferred Groomer
						</Typography>
						<TextField
							select
							style={{
								minWidth: '400px',
								margin: 0
							}}
							label="Team Member Name"
							variant="filled"
							disabled={visit?.status?.id === 5}
							value={visit.preferred_staff_id}
							type="number"
							onChange={(e) => setVisit({ ...visit, preferred_staff_id: e.target.value })}>
							{staffList
								?.filter(
									(s) =>
										s.active === true &&
										(s?.position === 'Groomer' || s.position === 'Groom Tech')
								)
								.map((staff) => {
									return (
										<MenuItem value={staff._id}>
											{staff.contact.last_name}, {staff.contact.first_name}
										</MenuItem>
									)
								})}
						</TextField>
					</div>
					<div className={classes.column} style={{ marginLeft: 24 }}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Assigned Groomer
						</Typography>
						<TextField
							select
							style={{
								minWidth: '400px',
								margin: 0
							}}
							label="Team Member Name"
							variant="filled"
							disabled={visit?.status?.id === 5}
							value={visit.staff_id}
							type="number"
							onChange={(e) => setVisit({ ...visit, staff_id: e.target.value })}>
							{staffList
								?.filter((s) => {
									// console.log(s.market_id, visit.market_id)

									return (
										s.active === true &&
										(s?.position === 'Groomer' || s.position === 'Groom Tech') &&
										s.market_id === visit.market_id
									)
								})
								.map((staff) => {
									return (
										<MenuItem value={staff._id}>
											{staff.contact.last_name}, {staff.contact.first_name}
										</MenuItem>
									)
								})}
						</TextField>
					</div>
				</div>
				<div className={classes.textField}>
					<div className={classes.column}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8,
								marginTop: 12
							}}>
							Trim Amount
						</Typography>
						<TextField
							select
							style={{
								minWidth: '400px',
								margin: 0
							}}
							label="Trim Amount"
							variant="filled"
							disabled={visit?.status?.id === 5}
							value={visit.trim_amount}
							type="number"
							onChange={(e) => setVisit({ ...visit, trim_amount: e.target.value })}>
							{trim_amounts.map((amount) => {
								return <MenuItem value={amount}>{amount}</MenuItem>
							})}
						</TextField>
					</div>
				</div>

				<Typography variant="body1" className={classes.header}>
					Appointment Pricing
				</Typography>

				<div className={classes.textField2}>
					<div className={classes.priceColumn}>
						<div style={{ marginBottom: 8 }}>
							<Typography variant="overline">Quoted Price Range</Typography>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',
								width: '100%'
							}}>
							<TextField
								style={{
									minWidth: '150px',
									margin: 0
								}}
								label="Price"
								variant="filled"
								disabled={visit?.status?.id === 5 || !canEditPrices}
								value={formatNumsToDollars(onlyNumbers(visit.quoted_price_min || 0))}
								InputProps={{
									startAdornment: (
										<InputAdornment className={classes.currencyAdornment} position="start">
											$
										</InputAdornment>
									)
								}}
								onChange={(e) => setVisit({ ...visit, quoted_price_min: e.target.value })}
							/>
							<Typography>To</Typography>
							<TextField
								style={{
									minWidth: '150px',
									margin: 0
								}}
								label="Price"
								variant="filled"
								disabled={visit?.status?.id === 5 || !canEditPrices}
								value={formatNumsToDollars(onlyNumbers(visit.quoted_price_max || 0))}
								InputProps={{
									startAdornment: (
										<InputAdornment className={classes.currencyAdornment} position="start">
											$
										</InputAdornment>
									)
								}}
								onChange={(e) => setVisit({ ...visit, quoted_price_max: e.target.value })}
							/>
						</div>
					</div>
					<div className={classes.priceColumn2}>
						<div style={{ marginBottom: 8 }}>
							<Typography variant="overline">Price</Typography>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',
								width: '100%'
							}}>
							<TextField
								style={{
									minWidth: '150px',
									margin: 0
								}}
								label="Price"
								variant="filled"
								disabled={visit?.status?.id === 5 || !canEditPrices}
								value={formatNumsToDollars(onlyNumbers(visit.price || 0))}
								InputProps={{
									startAdornment: (
										<InputAdornment className={classes.currencyAdornment} position="start">
											$
										</InputAdornment>
									)
								}}
								onChange={(e) => setVisit({ ...visit, price: e.target.value })}
							/>
						</div>
					</div>
				</div>
				{!canEditPrices && (
					<Typography
						variant="body2"
						style={{
							color: '#666',
							fontSize: 13,
							marginTop: -8,
							marginBottom: 16
						}}>
						You do not have sufficient permissions to make this change. Please contact management team to make the necessary changes.
					</Typography>
				)}

				<Typography variant="body1" className={classes.header}>
					Reference Information
				</Typography>

				<div className={classes.textField} style={{ flexDirection: 'column' }}>
					<div className={classes.column} style={{ width: '100%' }}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Notes From Team
						</Typography>
						<TextField
							multiline
							style={{
								minWidth: '400px',
								width: '96%',
								margin: 0
							}}
							label="Notes from team"
							variant="filled"
							disabled={visit?.status?.id === 5}
							value={visit.notes_from_team}
							type="number"
							onChange={(e) => setVisit({ ...visit, notes_from_team: e.target.value })}
						/>
					</div>
					<div className={classes.column} style={{ width: '100%', marginTop: 24 }}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Notes From Client
						</Typography>
						<TextField
							multiline
							style={{
								minWidth: '400px',
								width: '96%',
								margin: 0
							}}
							label="Notes from client"
							variant="filled"
							disabled={visit?.status?.id === 5}
							value={visit.notes_from_client}
							type="number"
							onChange={(e) => setVisit({ ...visit, notes_from_client: e.target.value })}
						/>
					</div>
					<div className={classes.column} style={{ width: '100%', marginTop: 36, marginBottom: 48 }}>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Reference Photo
						</Typography>
						{renderPhoto()}
						<Button
							variant="outlined"
							onClick={() => {
								document.getElementById('addon-image').click()
							}}
							style={{
								color: '#6B4AD6',
								borderWidth: 1,
								borderColor: '#6B4AD6',
								fontSize: 14,
								fontWeight: '800',
								paddingTop: 7
							}}>
							Upload Photo
						</Button>
						<div className={classes.fileUpload}>
							<input
								hidden
								accept="image/*, application/pdf"
								className={classes.input}
								id={`addon-image`}
								type="file"
								ref={waiverInputRef}
								onChange={(e) => uploadFile(e)}
							/>
						</div>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						saveVisit()
					}}
					disabled={timeError ? true : false}
					color="secondary">
					{loading ? <CircularProgress /> : 'Save'}
				</Button>
				<Button
					variant="outlined"
					disabled={loading}
					onClick={() => {
						setIsShown(false)
					}}
					color="secondary">
					Cancel
				</Button>
			</DialogActions>
			<Confirmation
				isShown={daycareWarning}
				body={''}
				confirmButtonText="Continue"
				title="ARE YOU SURE?"
				setIsShown={showDaycareWarning}
				onConfirmDelete={confirmDaycareTime}>
				<Typography
					variant="body2"
					style={{
						fontFamily: 'Nunito',
						color: '#1A1A35',
						fontSize: '16px',
						lineHeight: '22px',
						fontWeight: '400',
						marginBottom: 16,
						marginTop: 6
						// marginTop: 16
					}}>
					Please schedule the grooming appointment for this client{' '}
					<span style={{ fontWeight: 'bold' }}>after 9:00am</span> as they have a related daycare
					appointment. If you proceed with a time before 9:00am, inform the client of both appointment
					start/drop-off times accordingly.
				</Typography>
			</Confirmation>
		</Dialog>
	)
}

export default EditAssignmentsDialog
